module.exports = __webpack_public_path__ + "static/img/36.eeae612.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/36.jpg
// module id = pjS2
// module chunks = 1